// =============================================================================
// Admin Clients API Calls
//
// Frontend utility for calling admin-protected client management routes.
// =============================================================================

import axios from "axios";
import { clientVitalsAPI } from "../secrets";
import { Client } from "../types/UserTypes";

interface RepairClientPayload {
  uid: string;
  name: string;
  email: string;
  ssn: string;
  firstName: string;
  middleName?: string;
  lastName: string;
  generation?: string;
  addressLineOne: string;
  city: string;
  state: string;
  zip: string;
  dateOfBirth: string;
}

export const fetchAllClients = async (): Promise<Client[]> => {
  const result = await axios.get(`${clientVitalsAPI}/admin/clients`);
  return result.data;
};

export const triggerClientMap = async (clientId: string): Promise<void> => {
  await axios.post(`${clientVitalsAPI}/admin/clients/${clientId}/trigger-map`);
};

export const reOnboardClient = async (clientId: string): Promise<void> => {
  await axios.post(`${clientVitalsAPI}/admin/clients/${clientId}/re-onboard`);
};

export const repairClient = async (
  payload: RepairClientPayload
): Promise<void> => {
  await axios.post(`${clientVitalsAPI}/admin/repair/client-credit`, payload);
};

